import { render, staticRenderFns } from "./greenDiamond.vue?vue&type=template&id=0bdc4219&scoped=true"
import script from "./greenDiamond.vue?vue&type=script&lang=js"
export * from "./greenDiamond.vue?vue&type=script&lang=js"
import style0 from "./greenDiamond.vue?vue&type=style&index=0&id=0bdc4219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc4219",
  null
  
)

export default component.exports